import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { EventosHero, Celebraciones, Process, FinalCTA } from "@/components/landing/Sections";

export const Route = createFileRoute("/eventos")({
  head: () => ({
    meta: [
      { title: "Eventos · SUSIEDAD" },
      {
        name: "description",
        content:
          "DJ y producción para cumpleaños, comuniones, bautizos, aniversarios, cenas de empresa, inauguraciones, fiestas privadas y salas. Sonido, iluminación, cabina, montaje y desmontaje. Málaga y toda España.",
      },
    ],
  }),
  component: () => (
    <div className="min-h-screen bg-background text-foreground">
      {/* La página abre con la sala a sangre, así que la cabecera flota encima
          en hueso en vez de empujarla hacia abajo. Mismo criterio que /bodas. */}
      <SiteHeader overlay />
      <main>
        <EventosHero />
        <Celebraciones />
        <Process />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  ),
});
